module.exports = __webpack_public_path__ + "img/tech.2c2a35ae.svg";